import { useCallback } from "react";

import { apiUrls } from "config";
import { useCompute } from "api";

import { useFetchDataFile } from "modules/data-files/api";
import { useCreateProject } from "modules/projects/api";

import {
  useGetInputFile,
  useGetCreateSpec,
  useGetAugmentSpec,
  useCreateStatus,
  useCreateError,
} from "./store";

export const useGetCreate = () => {
  const createProject = useCreateProject();
  const compute = useCompute(apiUrls.createProjectWithData, false);

  const inputData = useGetInputFile();
  const { data: inputFileDetails } = useFetchDataFile(inputData);

  const createSpec = useGetCreateSpec();
  const augmentSpec = useGetAugmentSpec();

  const [, setStatus] = useCreateStatus();
  const [, setError] = useCreateError();

  return useCallback(async () => {
    if (!createSpec) {
      setError("MUST select data, and set outcome");
      return;
    }
    if (createSpec.meta_data.outcomes.length === 0) {
      setError("MUST select data, and set outcome");
      return;
    }
    const colsToBeAdded = augmentSpec.create_spec.new_columns.map(
      (c) => c.name
    );
    if (Array.from(new Set(colsToBeAdded)).length < colsToBeAdded.length) {
      setError("Outcome Variable Names MUST ALL BE unique!!!");
      return;
    }
    const conflictingNames = colsToBeAdded.filter((c) =>
      (inputFileDetails?.columns || []).includes(c)
    );
    if (conflictingNames.length >= 1) {
      setError(
        `Outcome Variables (${conflictingNames.join(
          ", "
        )}) are already present in data. You might want to give them different names.`
      );
      return;
    }

    setStatus("in-progress");
    setError(null);

    const resp = await createProject(createSpec);
    if (resp.success) {
      if (augmentSpec) {
        try {
          await compute({
            data: augmentSpec,
            computeUrl: `${apiUrls.projects}/${resp.project.id}/create-and-add-data-file`,
          });
        } catch (e) {
          setError(e);
        }
      }
    } else if (resp.success === false) {
      setError(resp.error);
    }
    setStatus("completed");
    return resp;
  }, [
    inputData,
    inputFileDetails,
    createSpec,
    augmentSpec,
    createProject,
    compute,
    setStatus,
    setError,
  ]);
};

// export const useGetCreate = () => {
//   const createProject = useCreateProject();
//   const compute = useCompute(
//     `${apiUrls.projects}/new-project/create-and-add-data-file`,
//     false
//   );

//   const inputData = useRecoilValue(inputDataFileId);
//   const { data: inputFileDetails } = useFetchDataFile(inputData);

//   return useRecoilCallback(
//     ({ snapshot, set }) => async () => {
//       const createS = await snapshot.getPromise(createSpec);

//       if (createS.meta_data.outcomes.length === 0) {
//         set(projectCreateError, "MUST select data, and set outcome");
//         return;
//       }
//       const augmentS = await snapshot.getPromise(augmentSpec);
//       console.log(augmentS);

//       const colsToBeAdded = augmentS.create_spec.new_columns.map((c) => c.name);
//       if (Array.from(new Set(colsToBeAdded)).length < colsToBeAdded.length) {
//         set(projectCreateError, "Outcome Variable Names MUST ALL BE unique!!!");
//         return;
//       }
//       const conflictingNames = colsToBeAdded.filter((c) =>
//         (inputFileDetails?.columns || []).includes(c)
//       );
//       if (conflictingNames.length >= 1) {
//         set(
//           projectCreateError,
//           `Outcome Variables (${conflictingNames.join(
//             ", "
//           )}) are already present in data. You might want to give them different names.`
//         );
//         return;
//       }

//       set(projectCreateStatus, "in-progress");
//       set(projectCreateError, undefined);

//       const resp = await createProject(createS);
//       if (resp.success) {
//         if (augmentS) {
//           try {
//             await compute({
//               data: augmentS,
//               computeUrl: `${apiUrls.projects}/${resp.project.id}/create-and-add-data-file`,
//             });
//           } catch (e) {
//             set(projectCreateError, e);
//           }
//         }
//       } else if (resp.success === false) {
//         set(projectCreateError, resp.error);
//       }
//       set(projectCreateStatus, "completed");
//       return resp;
//     },
//     [inputFileDetails, compute]
//   );
// };
